/**
 * @file The Workslip Detail component.
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { WorkSlipsService } from '../workslips.service';
import { DetailBase } from '../../base/detail/detail.base';
import { UserService } from '../../user.service';
import { RoutesService } from '../../routes.service';
import { SettingsService } from '../../settings.service';
var WorkSlipDetailComponent = /** @class */ (function (_super) {
    tslib_1.__extends(WorkSlipDetailComponent, _super);
    /**
     * Constructs a WorkSlipDetailComponent.
     * @param configurationsService Service to get the configuration for this component.
     * @param router The angular router enabling navigation between the different form modes.
     * @param route The active route.
     * @param dialogService The dialog service.
     * @param alertsService The alerts service.
     * @param translateService The translation service.
     */
    function WorkSlipDetailComponent(userService, router, route, domainService, dialogService, alertsService, settingsService, translateService) {
        return _super.call(this, userService, router, route, domainService, dialogService, alertsService, settingsService, translateService) || this;
    }
    /**
     * Is called after the block name is set and the configuration is loaded.
     * Override this method to process the loaded configuration data.
     */
    WorkSlipDetailComponent.prototype.afterInitialize = function () {
        // Get the components
        var components = Object.create(this.configuration.components);
        if (components.length !== 4) {
            console.warn('WorkSlipDetailComponent needs four components.');
        }
        this.assignmentForm = components[0];
        this.spendTimesForm = components[1];
        this.customerForm = components[2];
        this.signatureForm = components[3];
    };
    WorkSlipDetailComponent.prototype.close = function () {
        // Not forget query params.
        RoutesService.navigateBack(this.router, this.route, this.route.snapshot.queryParams);
    };
    return WorkSlipDetailComponent;
}(DetailBase));
export { WorkSlipDetailComponent };
